// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /event/list.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeEventListBody,
  typeEventListOutput200,
} from "../../sdk/event/postEventList";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildEventListQueryKey(payload: typeEventListBody): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`leagueId:${JSON.stringify(payload.leagueId)}`);
  queryKeySegments.push(`day:${JSON.stringify(payload.day)}`);
  queryKeySegments.push(`timeZone:${JSON.stringify(payload.timeZone)}`);
  if (typeof payload.conferenceKey !== "undefined") {
    queryKeySegments.push(
      `conferenceKey:${JSON.stringify(payload.conferenceKey)}`,
    );
  }
  return ["post:event:eventList", "svc:events-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeEventListOutput200,
    unknown,
    typeEventListOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useEventList(
  payload: typeEventListBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildEventListQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postEventList(payload),
    ...resolvedOptions,
  });
}
